module.exports = __webpack_public_path__ + "img/summary-background-aviation.4f355654.svg";